// extracted by mini-css-extract-plugin
module.exports = {"content_main":"App_content_main__2swuJ"};